/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Tile_PrintInputs */

const tr_landing_telegram_tile_print = /** @type {(inputs: Landing_Telegram_Tile_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzaktan yazdırma: çıktı, mağazadaki yazıcıya anında iletilir.`)
};

const en_landing_telegram_tile_print = /** @type {(inputs: Landing_Telegram_Tile_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote printing: the output reaches the printer in your store instantly.`)
};

const de_landing_telegram_tile_print = /** @type {(inputs: Landing_Telegram_Tile_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferndruck: Der Ausdruck wird sofort an den Drucker im Laden übermittelt.`)
};

const ru_landing_telegram_tile_print = /** @type {(inputs: Landing_Telegram_Tile_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаленная печать: документ мгновенно отправляется на принтер в магазине.`)
};

/**
* | output |
* | --- |
* | "Remote printing: the output reaches the printer in your store instantly." |
*
* @param {Landing_Telegram_Tile_PrintInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_tile_print = /** @type {((inputs?: Landing_Telegram_Tile_PrintInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Tile_PrintInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_tile_print(inputs)
	if (locale === "de") return de_landing_telegram_tile_print(inputs)
	if (locale === "ru") return ru_landing_telegram_tile_print(inputs)
	return tr_landing_telegram_tile_print(inputs)
});